<template>
    <div class="messageIndex">
        <div class="message">
            <div class="item" @click="goPage('/kefu/chat')">
                <div class="icon_wrap" v-if="!indexDetail.unread">
                    <img :src="this.publicPath+'statics/images/my/icon_kefu.png'" class="icon" alt="">
                </div>
                <div class="icon_wrap unread" v-else>
                    <img :src="this.publicPath+'statics/images/my/icon_kefu.png'" class="icon" alt="">
                </div>
                <div class="txt">我的客服</div>
            </div>
            <div class="item" @click="goMsgList(1)">
                <!-- 无未读 -->
                <div class="icon_wrap" v-if="!indexDetail.xt_count">
                    <img :src="this.publicPath+'statics/images/my/icon_symxx.png'" class="icon" alt="">
                </div>
                <!-- 有未读-->
                <div class="icon_wrap unread" v-if="indexDetail.xt_count">
                    <img :src="this.publicPath+'statics/images/my/icon_symxx.png'" class="icon" alt="">
                </div>
                <div class="txt">系统消息</div>
            </div>
            <!-- 站内通告 商家角色展示 -->
            <div class="item" @click="goMsgList(2)" v-if="userrole.is_tradesman">
                <!-- 无未读 -->
                <div class="icon_wrap" v-if="!indexDetail.zn_count">
                    <img :src="this.publicPath+'statics/images/my/icon_tonggao.png'" class="icon" alt="">
                </div>
                <!-- 有未读 -->
                <div class="icon_wrap unread" v-if="indexDetail.zn_count">
                    <img :src="this.publicPath+'statics/images/my/icon_tonggao.png'" class="icon" alt="">
                </div>
                <div class="txt">站内通告</div>
            </div>
            <div class="item" @click="goPage('/message/order')">
                <!-- 无未读 -->
                <div class="icon_wrap" v-if="!indexDetail.order_count">
                    <img :src="this.publicPath+'statics/images/my/icon_orderxx.png'" class="icon" alt="">
                </div>
                <!-- 有未读 -->
                <div class="icon_wrap unread" v-if="indexDetail.order_count">
                    <img :src="this.publicPath+'statics/images/my/icon_orderxx.png'" class="icon" alt="">
                </div>
                <div class="txt">订单信息</div>
            </div>
        </div>
        <!-- 消息 -->
        <div class="con page_message_list">
            <van-pull-refresh v-model="refreshing" :head-height="80" @refresh="onRefresh">
                <!-- 下拉提示，通过 scale 实现一个缩放效果 -->
                <template #pulling="props">
                    下拉刷新
                </template>

                <!-- 释放提示 -->
                <template #loosing>
                    释放请求...
                </template>

                <!-- 加载提示 -->
                <template #loading>
                    加载中...
                </template>
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list">
                    <div v-for="(item,key) in msglist" :key="key" class="clearfix item" @click="goTradesmanChat(item)">
                        <div class="f-l thumb">
                            <!-- {{ JSON.stringify(item) }} -->
                            <img v-if="im_userName == item.from_im_username && item.to_tradesman != null" :src="item.to_tradesman.thumb ? ($publicData.withHttpStart(item.to_tradesman.thumb) ? item.to_tradesman.thumb : $publicData.uploadImage+item.to_tradesman.thumb) : ''" alt="">
                            <img v-else-if="im_userName == item.from_im_username && item.to_tradesman == null" :src="item.to_userdata.thumb ? ($publicData.withHttpStart(item.to_userdata.thumb) ? item.to_userdata.thumb : $publicData.uploadImage+item.to_userdata.thumb) : ''" alt="">
                            <img v-else-if="im_userName == item.to_im_username && item.from_tradesman != null" :src="item.from_tradesman.thumb ? ($publicData.withHttpStart(item.from_tradesman.thumb) ? item.from_tradesman.thumb : $publicData.uploadImage+item.from_tradesman.thumb ) : ''" alt="">
                            <img v-else-if="im_userName == item.to_im_username && item.from_tradesman == null" :src="item.from_userdata.thumb ? ($publicData.withHttpStart(item.from_userdata.thumb) ? item.from_userdata.thumb : $publicData.uploadImage+item.from_userdata.thumb) : ''" alt="">
                            <img v-else :src="publicPath+'statics/images/my/icon_kefu.png'" alt="">
                            <!-- {{ im_userName }} -->
                        </div>
                        <div class="f-l info">
                            <div class="top clearfix">
                                <span class="user_name f-l">{{ item.showNickname }}</span>
                                <span class="f-r time">{{ formateDate(item.updated_at) }}</span>
                            </div>
                            <div class="bottom clearfix">
                                <div class="f-l txt" v-if="item.msg">{{ item.msg.indexOf('dingzhi://')!=-1?'定制':item.msg.indexOf('dingzhiOrder://')!=-1?'定制单': item.msg.indexOf('tradesmanDingzhi://')!=-1? '匠人定制单' :item.msg }}</div>
                                <!-- <div v-if="item.hasUnread" class="f-r nums"></div> -->
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import router from "../../../.././router";
    import {
        LOGOUT,
        LOGIN
    } from "../../../.././vuex/mutation_types";
    import Vue from 'vue';
    import Bridge from '../../../.././vuex/bridge.js'
import { Toast } from 'vant';
    Vue.prototype.$bridge = Bridge
    var userAgent = navigator.userAgent

    export default {
        data() {
            return {
                ordertab: 'a',
                publicPath: process.env.BASE_URL,
                message: '暂无我的客服消息',
                token: null,
                uuid: null,
                indexDetail: {}, // 各分类的数量
                msglist: [],    // 消息列表
                userrole: {}, // 用户角色
                pages: {
                    page: 1,
                    size: 10
                },
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                im_userName: null,
                im_password: null
            };
        },
        beforeMount(to, from, next) {
            // 清除消息缓存
            this.$publicData.webimconn.mr_cache = [];
        },
        created: function () {
            var that = this
            //根据userAgent判断是否在iOSAndroid客户端中
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                // that.$parent.getWebIMInfo()
                that.setClientInfo()
                //注册方法，客户端重新进入页面刷新数据
                this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                    console.log('sdjy://common/refreshPage')
                    that.setClientInfo()
                    // alert(JSON.stringify(data));
                    responseCallback(data)
                })
            } else {

                // 获取列表
                this.token = this.$store.getters.token
                this.uuid = this.$store.getters.uuid
                const userInfo = localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"));
                // 有记录用户信息
                if (userInfo) {
                    this.im_userName = userInfo.userId;
                    this.im_password = userInfo.password;
                }
                // 获取列表
                this.getUnreadMsg();
                // 获取环信用户信息
                this.getHXUserInfo();
                // 获取消息列表
                // this.getMsgList();
                this.getUserRole();
            }
			console.log('vue对象',this)
        },
        mounted: function () {
            var logout = this.$publicData.isIMLogout
            console.log('11222:',logout)
            if (logout) {
                Toast('您的聊天账号已在其他地方登录，请刷新页面')
            }
        },
        methods: {
            setClientInfo() {
                console.log('setClientInfo')
                this.$publicData.webimconn.mr_cache = [];
                //修改导航栏样式
                var params = {
                    'data': {
                        'naviTitle': '消息',
                        'hiddenBack': true
                    }
                }
                this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

                })
                //获取用户信息
                var memberParams = {
                    'data': {
                        'notCallLogin': 1,
                    }
                }
                console.log('sdjy://member/memberInfo')
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token
                        this.uuid = data.result.uuid
                        this.im_userName = data.result.im_username;
                        this.im_password = data.result.im_pwd;
                        console.log('this.im_userName:', this.im_userName)
                        this.$parent.getWebIMInfo()
                        // this.$publicData.webimconn.mr_cache = [];
                        // 获取列表
                        this.getUnreadMsg();
                        // 获取环信用户信息
                        this.getHXUserInfo();
                        // 获取消息列表
                        // this.getMsgList();
                        this.getUserRole();
                    }
                })
            },
            // 获取信息首页数据 （列表，未读消息数量）
            getUnreadMsg() {
                var that = this;
                var params = {
                    token: that.token
                }
                that.$api.xiaoxi.msgIndex(params).then(res => {
                    // console.log('1111未读消息列表：', res)
                    if (res.code == 200) {
                        that.indexDetail = res.result;

                        that.getHistoryMsg(0);

                        // setTimeout(function() {
                        //     var list = nlist;
                        //     console.log('list:', list)
                        //     if (list.length > 0) {
                        //         let group = parseInt(list.length / 10);
                        //         console.log(group);

                        //         for (var i = 0; i < list.length; i++) {
                        //             that.$parent.getHistoryMessage({ name: list[i].to_im_username, isGroup: false, count: 1 }, function (msgs) {
                        //                 console.log("这是拿到的信息列表：", msgs[0].data);
                        //                 list[i].msg = msgs[0].data;

                        //             });
                        //         }

                        //         that.indexDetail.list = list;
                        //     }
                        // },1000)

                        // console.log(that.$publicData)
                    }
                })
            },
            // 获取每条记录的最后一条历史消息
            getHistoryMsg(ind) {
                var that = this;
                var reslist = that.indexDetail.list;

                // 历史列表
                var msghistorylist = localStorage.getItem("msghistorylist");
                if (!msghistorylist) {
                    msghistorylist = [];
                } else {
                    msghistorylist = JSON.parse(msghistorylist);
                }

				var imsg = reslist[ind];
				console.log('最后一条信息',imsg)
                console.log('imsg.to_im_username:', imsg.to_im_username)
                var to_im_username = this.im_userName == imsg.from_im_username ? imsg.to_im_username : imsg.from_im_username
                // console.log('imsg.to_im_username:::',imsg.to_im_username)
                if (to_im_username != null && to_im_username != '') {
                    // 有匠人信息，已注册环信
                    that.$parent.getHistoryMessage({ name: to_im_username, isGroup: false, count: 1 }, function (msgs) {
                        if (ind == 0) {
                            that.msglist = [];
                        }
                        // console.log("这是拿到的信息列表：", msgs.length >0 ? msgs[0].data : '没有数据');
                        var hasUnread = true;
                        if (msgs.length > 0) {
                            for (var i in msghistorylist) {
                                if (msghistorylist[i].to_user == imsg.to_im_username) {
                                    if (msghistorylist[i].time <= msgs[0].time) {
                                        hasUnread = false;
                                    }
                                }

                            }
                        }

                        var o = {
                            created_at: imsg.created_at,
                            from_im_username: imsg.from_im_username,
                            from_tradesman_username: imsg.from_tradesman != null ? imsg.from_tradesman.nickname : '',
                            from_tradesman: imsg.from_tradesman,
                            from_userdata: imsg.from_userdata,
                            from_uuid: imsg.from_uuid,
                            id: imsg.id,
                            to_im_username: imsg.to_im_username,
                            to_tradesman_name: imsg.to_tradesman != null ? imsg.to_tradesman.nickname : '',
                            to_tradesman: imsg.to_tradesman,
                            to_userdata: imsg.to_userdata,
                            to_uuid: imsg.to_uuid,
                            updated_at: imsg.updated_at,
                            msg: msgs.length > 0 ? msgs[0].data : '',
                            hasUnread: hasUnread
                        }
                        var nickname = ''
                        // console.log('that.im_userName:',that.im_userName)
                        // console.log('imsg.from_im_username:',imsg.from_im_username)

                        if (that.im_userName != imsg.from_im_username) {
                            console.log('imsg.from_tradesman:::::::::', imsg.from_tradesman)
                            // 对方如果是匠人
                            if (imsg.from_tradesman != null && imsg.from_tradesman.nickname != null && imsg.from_tradesman.nickname != undefined && imsg.from_tradesman.nickname != '') {
                                nickname = imsg.from_tradesman.nickname
                            } else if (imsg.from_userdata.nickname != null && imsg.from_userdata.nickname != undefined && imsg.from_userdata.nickname != '') {
                                nickname = imsg.from_userdata.nickname
                            } else {
                                nickname = imsg.from_userdata.username
                            }

                        } else {
                            if (imsg.to_tradesman.nickname != null && imsg.to_tradesman.nickname != undefined && imsg.to_tradesman.nickname != '') {
                                nickname = imsg.to_tradesman.nickname
                            } else if (imsg.to_userdata.nickname != null && imsg.to_userdata.nickname != undefined && imsg.to_userdata.nickname != '') {
                                nickname = imsg.to_userdata.nickname
                            } else {
                                nickname = imsg.to_userdata.username
                            }
                        }
                        o.showNickname = nickname
						that.msglist.push(o);
						console.log('历史信息',that.msglist)
                        console.log('长度：', reslist.length, ind)
                        if (reslist.length - 1 > ind) {
                            var i = ind + 1;
                            that.getHistoryMsg(i);
                        }
                        // else {
                        //     that.$parent.reloadHX();
                        // }

                    });
                } else {
                    if (reslist.length - 1 > ind) {
                        var i = ind + 1;
                        that.getHistoryMsg(i);
                    }
                }
                // for (var i = 0; i < reslist.length; i++) {
                //     var imsg = reslist[i];

                // }
            },
            // 获取环信用户信息
            getHXUserInfo() {
                this.$api.xiaoxi.userInfo({
                    token: this.token,
                    uuid: this.uuid
                }).then(res => {
                    // console.log(res);
                    if (res.code == 200) {
                        console.log('获取环信用户信息:')
                        console.log(res.result)
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }

                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1);
                    }
                    this.loading = false;

                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.list = [];
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
            },
            // 获取消息列表
            getMsgList() {
                let params = {
                    token: this.token,   //	是	string	token
                    sys_msg_cate_id: 2, //	是	int	1 系统消息 2站内消息 (默认1)
                    page: this.pages.page,  //	否	int	页码 （1）
                    size: this.pages.size,  //	否	int	每页显示数量（10）
                }
                this.$api.xiaoxi.msgList(params).then(res => {

                })
            },
            goPage(path) {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + path
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    });

                } else {
                    this.$router.push({
                        path: path
                    })
                }

            },
            // 匠人聊天
            goTradesmanChat(item) {
                console.log(item)
                var that = this;
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                        if (data.code == 200) {

                            this.token = data.result.token;
                            var uuid = this.im_userName == item.from_im_username ? item.to_uuid : item.from_uuid
                            var params = {
                                token: this.token,
                                uuid: uuid
                            };
                            that.$api.xiaoxi.userInfo(params).then(res => {
                                if (res.code == 200) {
                                    var tradesmanInfo = res.result;
                                    // console.log('创建了与匠人的通信')
                                    // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);
                                    console.log('toAppServe:userInfo')
                                    that.toAppServe(item, tradesmanInfo);

                                }
                            })
                        }
                    });
                } else {
                    let uuid = this.im_userName == item.from_im_username ? item.to_uuid : item.from_uuid
                    this.$router.push({
                        path: '/tradesman/chat',
                        query: {
                            uuid: uuid
                        }
                    })
                }
            },
            toAppServe(tradesmanInfo, tradesman) {
                // console.log('toAppServe')
                // console.log(tradesmanInfo)
                // return
                this.$parent.msgLogOut()
                var uuid = this.im_userName == tradesmanInfo.from_im_username ? tradesmanInfo.to_uuid : tradesmanInfo.from_uuid
                var to_im_username = this.im_userName == tradesmanInfo.from_im_username ? tradesmanInfo.to_im_username : tradesmanInfo.from_im_username
                var trandsmanId = this.im_userName == tradesmanInfo.from_im_username ? tradesmanInfo.to_uuid : tradesmanInfo.from_uuid
                var params = {
                    data: {
                        toId: to_im_username,
                        conversationId: to_im_username,
                        toAvator: tradesmanInfo.thumb,
                        toName: tradesmanInfo.showNickname,
                        toUUID: uuid,
                        toPhone: tradesmanInfo.tradesmans.data.phone,
                        trandsmanId: tradesman.tradesmans.id
                    },
                }
                this.$bridge.callhandler("sdjy://public/chat", params, (data) => {

                });
            },
            // 消息列表（站内/系统）
            goMsgList(type) {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/message/system?type=' + type
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    });

                } else {
                    // 1 系统消息  2站内消息
                    this.$router.push({
                        path: '/message/system',
                        query: {
                            type: type
                        }
                    })
                }

            },
            // 获取用户角色
            getUserRole() {
                var params = {
                    token: this.token
                }
                this.$api.user.index(params).then(res => {
                    if (res.code == 200) {
                        this.userrole = res.result.info.userrole
                    }
                })
            },
            // 格式化日期
            formateDate(time) {
                time = time.replace(/-/g,'/');
                // console.log(parseInt(time))
                let dates = new Date(time);
                var fDate = dates.getFullYear() + '/' + (dates.getMonth() + 1 < 10 ? '0' + (dates.getMonth() + 1): dates.getMonth() + 1) + '/' + (dates.getDate() < 10 ? '0' + dates.getDate() : dates.getDate());
                var fTime = (dates.getHours() < 10 ? '0' + dates.getHours() : dates.getHours()) + ':' + (dates.getMinutes() < 10 ? '0' + dates.getMinutes()  : dates.getMinutes()) + ':' + (dates.getSeconds() < 10 ? '0' + dates.getSeconds() : dates.getSeconds() );

                // 获取今天
                var today = new Date();
                var tDate = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate();
                if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime()) {
                    return '今天 ' + fTime;
                } else if (new Date(fDate + ' 00:00:00').getTime() == new Date(tDate + ' 00:00:00').getTime() - 24 * 3600 * 1000) {
                    return '昨天 ' + fTime;
                } else {
                    return fDate + ' ' + fTime;
                }
            },
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .page_message_list {
        width: 10rem;
        margin: 0 auto;
        position: absolute;
        top: 2.4rem;
        bottom: 1.32rem;
        overflow-y: auto;
        z-index: 1;
    }
</style>